module.exports = __webpack_public_path__ + "static/media/logo_header_colour_with_text.57394974.png";